import component from './VariantsConstructor.vue'
export default component
